import useTranslation from 'next-translate/useTranslation';

/* eslint-disable-next-line */
export interface ScoreTagProps {
  score: number;
}

export function ScoreTag({ score }: ScoreTagProps) {
  const { t } = useTranslation('common');

  switch (score) {
    case 5:
      return (
        <span className="px-2 py-0.5 rounded-full text-white bg-green-600">
          {t('perfect_match')}
        </span>
      );
    case 4:
      return (
        <span className="px-2 py-0.5 rounded-full text-white bg-green-600">
          {t('great_match')}
        </span>
      );
    case 3:
      return (
        <span className="px-2 py-0.5 rounded-full text-white bg-green-500">
          {t('good_match')}
        </span>
      );
    case 2:
      return (
        <span className="px-2 py-0.5 rounded-full text-white bg-yellow-600">
          {t('moderate_match')}
        </span>
      );
    case 1:
      return (
        <span className="px-2 py-0.5 rounded-full text-white bg-orange-600">
          {t('low_match')}
        </span>
      );
    default:
      return (
        <span className="px-2 py-0.5 rounded-full text-white bg-red-600">
          {t('bad_match')}
        </span>
      );
  }
}

export default ScoreTag;
